// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: "https://monitor.bellacanvas.com/cgi-bin/livevpw/wam_tmpl/", 
  layout: "bel_mp", 
  content: "json",
  site: "belmp",
  firebase : {
    apiKey: "AIzaSyA3WtKLwYOuwXHlM625KOBorx6arXZZMlk",
    authDomain: "monitoring-app-51f8f.firebaseapp.com",
    projectId: "monitoring-app-51f8f",
    storageBucket: "monitoring-app-51f8f.appspot.com",
    messagingSenderId: "926762594401",
    appId: "1:926762594401:web:61d5079d38028ef3e5fa20",
    measurementId: "G-F8D8QNETR4"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
